<template>
  <v-app-bar
    height="76"
    absolute
    flat
    extended
    extension-height="36"
    class="flex-col-reverse"
  >
    <template #extension>
      <header-extension />
    </template>

    <v-container class="py-0 flex align-center justify-space-between">
      <header-logo />

      <div
        v-if="lgAndUp"
        class="ms-auto"
      >
        <template
          v-for="(menu, index) in items"
          :key="index"
        >
          <header-menu-activator
            :disabled="!menu.mainLinks?.length"
            :activator-props="{ icon: false, text: menu.mainLink?.text }"
          >
            <v-defaults-provider :defaults="{ VSheet: { class: 'border border-[#DDE4EF] flex flex-nowrap' } }">
              <header-menu :menu="menu" />
            </v-defaults-provider>
          </header-menu-activator>
        </template>

        <template v-if="['pro'].includes($vuetify.theme.name)">
          <v-defaults-provider :defaults="{ VBtn: { variant: 'flat' } }">
            <storyblok-component
              v-for="(btn, i) in joinUnbiased"
              :key="i"
              :blok="btn"
              :variant="btn.variant"
              :size="btn.size"
              :text="btn.text"
              class="ms-4"
              @click="toggleJoinUnbiasedDialog()"
            />
          </v-defaults-provider>
        </template>
      </div>
    </v-container>

    <template
      v-if="mdAndDown"
      #append
    >
      <header-menu-activator
        v-model="openedMenu"
        width="100%"
        :activator-props="{ width: 40, icon: true }"
        :content-props="{ class: 'rounded-0 border-0' }"
        :close-on-content-click="false"
        scroll-strategy="block"
        :height="menuHeight"
        :location-strategy="locationStrategy"
        @update:model-value="updateMenu"
      >
        <v-sheet
          height="100%"
          width="100%"
          rounded="0"
          elevation="0"
          class="px-4"
        >
          <header-menu-group
            v-slot="{ menu }"
            v-model:opened="openedGroup"
            :items="items"
            class="mb-4 -mx-4"
          >
            <header-menu :menu="menu" />
          </header-menu-group>

          <template v-if="['pro'].includes($vuetify.theme.name)">
            <v-defaults-provider :defaults="{ VBtn: { variant: 'flat' } }">
              <storyblok-component
                v-for="(btn, i) in joinUnbiased"
                :key="i"
                :blok="btn"
                :variant="btn.variant"
                :size="btn.size"
                :text="btn.text"
                block
                @click="toggleJoinUnbiasedDialog()"
              />
            </v-defaults-provider>
          </template>
        </v-sheet>
      </header-menu-activator>
    </template>
  </v-app-bar>
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import type { HeaderMenuStoryblok } from '#core/storyblok-component-types'

defineProps<{
  items: HeaderMenuStoryblok[]
  joinUnbiased?: any[]
}>()

const router = useRouter()
const { lgAndUp, mdAndDown, height } = useDisplay()
const { mainRect } = useLayout()
const joinUnbiasedDialog = useJoinUnbiasedDialog()
const toggleJoinUnbiasedDialog = useToggle(joinUnbiasedDialog)
const menuHeight = computed(() => height.value - mainRect.value.top)

const openedMenu = ref(false)
const openedGroup = ref<never[]>([])

// TODO: Temporary fix for mobile menu
interface LocationStrategyData {
  contentEl: Ref<HTMLElement | undefined>
}

const locationStrategy = (data: LocationStrategyData, _: never, contentStyles: Ref<Record<string, string>>) => {
  function updateLocation() {
    Object.assign(contentStyles.value, {
      bottom: 0,
    })
  }

  useResizeObserver(data.contentEl, () => {
    updateLocation()
  })

  return {
    updateLocation,
  }
}

function updateMenu(value: boolean) {
  if (!value) {
    openedGroup.value = []
  }
}

const stopWatchRoute = watch(() => router.currentRoute.value, () => {
  openedMenu.value = false
})

onScopeDispose(() => {
  stopWatchRoute()
})
</script>

<style scoped lang="scss">

</style>
